var messages = {
  placeholder: '请输入',
  passwordPlaceholder: '请输入密码'
};
export default messages;